import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NgxPendoModule } from 'ngx-pendo';

import { PendoService } from './pendo.service';

@NgModule({
  imports: [CommonModule, NgxPendoModule],
  providers: [PendoService],
})
export class PendoModule {}
